// Module
var code = "<div class=\"sb-fill-checklist animate-from-left\" ng-class=\"{'open': $ctrl.isOpen}\"> <sb-app-checklist ng-if=\"$ctrl.isOpen\" id=\"angular-checklist\"> </sb-app-checklist> </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/deliverables/sbDeliverableChecklists/panels/sbFillChecklistPanel/fill_checklist_panel.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;